<template>
  <Teleport to="body">
    <div class="modal-overlay" @click.self="closeModal('close')">
      <div class="modal-content">
        <h2>
          {{
            ` دوست عزیزم برای چرخوندن این دور (${costGame.bon_count}) تا بن ازت کم میشه `
          }}
        </h2>

        <div class="modal-actions">
          <button @click="closeModal('confirm')" class="btn-confirm">
            باشه
          </button>
          <button @click="closeModal('close')" class="btn-cansel">
            انصراف
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  props: {
    costGame: Object,
  },
  methods: {
    closeModal(type) {
      if (type == "close") {
        this.$emit("visible", { close: true, confirm: false });
      } else if (type == "confirm") {
        this.$emit("visible", { close: true, confirm: true });
      }
    },
  },
};
</script>

<style scoped>
h2 {
  margin-bottom: 30px;
  font-size: 24px;
  font-weight: 700;
}
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
}

.modal-content {
  background: white;
  padding: 40px;
  border-radius: 10px;
  text-align: center;
  width: 600px;
}

.code-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f1f1f1;
  padding: 15px;
  margin: 10px 0;
  border-radius: 5px;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.btn-confirm {
  background: #faabcf;
  width: 80px;
  border: none;
  padding: 10px 15px;
  cursor: pointer;
  border-radius: 5px;
}
.btn-cansel {
  background: #fa0338;
  width: 80px;
  border: none;
  padding: 10px 15px;
  cursor: pointer;
  border-radius: 5px;
  color: white;
}

@media screen and (max-width: 768px) {
  .modal-content {
    background: white;
    padding: 40px;
    border-radius: 10px;
    text-align: center;
    width: 80%;
  }
  .btn-confirm {
    background: #faabcf;

    border: none;
    padding: 6px 15px;
    cursor: pointer;
    border-radius: 5px;
  }
}
@media screen and (max-width: 640px) {
  .modal-content {
    width: 90%;
  }
  h2 {
    margin-bottom: 30px;
    font-size: 20px;
  }
}
</style>
